<script>

import * as fields from './fields';

export default {

	functional: true,

	props: {
		field: {
			type: Object,
			required: true
		},
		module: {
			type: Object,
			default: () => ({}),
		},
		parentModules: {
			type: Array,
			default: () => ([]),
		},
	},

	render(createElement, context) {
		const component = () => {
			if (!context.props.field.type) {
				return 'div';
			}

			switch (context.props.field.type) {
				case 'associated_module':
					return fields[ context.props.field.type ];
				default:
					return fields[ context.props.field.type ] || fields.default;
			}
		};

		return createElement(
			component(),
			{
				...context.data,
				attrs: {
					...context.data.attrs,
					...context.props,
				},
			},
			context.children
		);
	}
};

</script>
